






















































import {Component, Vue} from "vue-property-decorator";
import TermsAndConditionsLink from "@app/shared/components/termsAndConditions/termsAndConditionsLink.vue";
import * as _ from "lodash";
import * as ApplicationStore from "@src/store/applicationStore";
import {OrganisationController} from "@proxy/OrganisationController";

@Component({
  components: {
    TermsAndConditionsLink
  }
})

export default class AdditionalInfo extends Vue {
  private get contactDetails(): Array<ProxyModel.ContactDetailViewModel> {
    return [
      {name: "Lex Medicus", tel: "1300 633 453", email: "info@lexmedicus.com.au"},
    ];
  }

  get isOfba(): boolean {
    return ApplicationStore.isOfba(this.$store);
  }
}
